import { defineMessages } from 'react-intl';

// list of API-validated keys
export const INPUT_KEYS = {
  PME_PIECES: 'pmePieces',
  PM_PIECES: 'pmPieces',
  FCM_PIECES: 'fcmPieces',
  INTL_PIECES: 'intlPieces',
  OTHER_PIECES: 'otherPieces',
  TOTAL_WEIGHT: 'totalWeightOZ',
  PICKUP_LOCATION: 'pickupLocation',
  SPECIAL_INSTRUCTION: 'specialInstruction',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  COMPANY: 'company',
};

const SERVICE_TYPES = [
  {
    key: INPUT_KEYS.PME_PIECES,
    name: 'Priority Mail Express',
  },
  {
    key: INPUT_KEYS.PM_PIECES,
    name: 'Priority Mail',
  },
  {
    key: INPUT_KEYS.FCM_PIECES,
    name: 'First Class Mail',
  },
  {
    key: INPUT_KEYS.INTL_PIECES,
    name: 'International',
  },
  {
    key: INPUT_KEYS.OTHER_PIECES,
    name: 'Other',
  },
];

export const getServiceCountArray = (pickup) => {
  return SERVICE_TYPES.map((service) => {
    return {
      ...service,
      count: pickup[service.key],
    };
  });
};

export const PICKUP_ACTIONS = {
  GET_API_DATA: 'getApiData',
  ON_API_ERROR: 'onApiError',
  INPUT_CHANGE: 'inputChange',
  DROPDOWN_CHANGE: 'dropdownChange',
  REQUEST_PICKUP: 'requestPickup',
  CANCEL_PICKUP: 'cancelPickup',
};

const messages = defineMessages({
  frontDoor: {
    description: 'USPS Pickup Location Dropdown FrontDoor',
    defaultMessage: 'Front door',
    id: 't6mUeX',
  },
  backDoor: {
    description: 'USPS Pickup Location Dropdown BackDoor',
    defaultMessage: 'Back Door',
    id: 's9CV3c',
  },
  sideDoor: {
    description: 'USPS Pickup Location Dropdown SideDoor',
    defaultMessage: 'Side door',
    id: 'ap3YBh',
  },
  knockOnDoorOrRingBell: {
    description: 'USPS Pickup Location Dropdown KnockOnDoorOrRingBell',
    defaultMessage: 'Knock on door or ring bell',
    id: '3fISxT',
  },
  mailRoom: {
    description: 'USPS Pickup Location Dropdown MailRoom',
    defaultMessage: 'Mail Room',
    id: 'HNjYnO',
  },
  office: {
    description: 'USPS Pickup Location Dropdown Office',
    defaultMessage: 'Office',
    id: '25MUFZ',
  },
  reception: {
    description: 'USPS Pickup Location Dropdown Reception',
    defaultMessage: 'Reception',
    id: 'pwsTJr',
  },
  inOrAtMailbox: {
    description: 'USPS Pickup Location Dropdown InOrAtMailbox',
    defaultMessage: 'In or at mailbox',
    id: 'zf1iUZ',
  },
  other: {
    description: 'USPS Pickup Location Dropdown Other',
    defaultMessage: 'Other',
    id: '5REhL0',
  },
});

export const LOCATION_OPTIONS = [
  {
    displayName: messages.frontDoor,
    apiValue: 'FrontDoor',
  },
  {
    displayName: messages.backDoor,
    apiValue: 'BackDoor',
  },
  {
    displayName: messages.sideDoor,
    apiValue: 'SideDoor',
  },
  {
    displayName: messages.knockOnDoorOrRingBell,
    apiValue: 'KnockOnDoorOrRingBell',
  },
  {
    displayName: messages.mailRoom,
    apiValue: 'MailRoom',
  },
  {
    displayName: messages.office,
    apiValue: 'Office',
  },
  {
    displayName: messages.reception,
    apiValue: 'Reception',
  },
  {
    displayName: messages.inOrAtMailbox,
    apiValue: 'InOrAtMailbox',
  },
  {
    displayName: messages.other,
    apiValue: 'Other',
  },
];

export const PICKUP_LOCATION_VALUE_REQUIRES_SPECIALINSTRUCTIONS = 'Other';

export const STATE_FOR_API_ERROR = {
  futurePickup: {
    company: '',
    confirmationNumber: '',
    fcmPieces: null,
    firstName: null,
    intlPieces: null,
    isSubmitted: null,
    lastName: null,
    otherPieces: null,
    pmePieces: null,
    pmPieces: null,
    pickupDate: null,
    pickupLocation: null,
    pickupRequestID: null,
    sellerID: null,
    specialInstruction: null,
    totalWeightOZ: null,
    warehouseID: null,
  },
  todaysPickup: {
    pmePieces: null,
    pmPieces: null,
    fcmPieces: null,
    intlPieces: null,
    otherPieces: null,
    totalWeightOZ: null,
    pickupLocation: null,
    isSubmitted: null,
    specialInstruction: null,
  },
  nextAvailable: null,
  hasApiError: true,
};

const POST_BODY_SHAPE_V3 = {
  pmePieces: 1,
  pmPieces: 1,
  fcmPieces: 1,
  intlPieces: 1,
  otherPieces: 1,
  totalWeightOZ: 1,
  isSubmitted: 0,
  specialInstruction: 'string',
  pickupLocation: 'string',
  company: 'string',
  firstName: 'string',
  lastName: 'string',
  warehouseID: 1,
  pickupDate: '01/26/2021',
};

export const generatePickupRequestBody = (pickup) => {
  const postBody = {};
  Object.keys(POST_BODY_SHAPE_V3).forEach((key) => {
    postBody[key] = pickup[key];
  });
  return postBody;
};
